<template>
  <div class="about">
    <h1>A Site for Events to Better the World 🌎</h1>
  </div>
</template>
